import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiClipboard, FiX } from 'react-icons/fi';
import { USER_ROLES } from '../../utils/constants';
import clsx from 'clsx';

const MobileMenu = ({ isOpen, onClose }) => {
  const { user } = useAuth();

  const navigationItems = [
    {
      name: 'Mis Órdenes',
      href: '/orders/mobile',
      icon: FiClipboard,
      show: user?.role === USER_ROLES.CLEANING_STAFF,
    },
  ];

  const filteredNavigation = navigationItems.filter(item => item.show);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50">
      <div className="fixed inset-y-0 right-0 w-64 bg-white shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">
            Menu
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100"
          >
            <FiX className="h-5 w-5" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="mt-4 px-4">
          <ul className="space-y-2">
            {filteredNavigation.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  onClick={onClose}
                  className={({ isActive }) =>
                    clsx(
                      'flex items-center px-3 py-3 rounded-lg text-base font-medium transition-colors duration-200',
                      {
                        'bg-blue-100 text-blue-700': isActive,
                        'text-gray-700 hover:bg-gray-100 hover:text-gray-900': !isActive,
                      }
                    )
                  }
                >
                  <item.icon className="mr-3 h-6 w-6" />
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* User info */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center">
            <div className="h-10 w-10 bg-blue-500 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-white">
                {user?.name?.charAt(0)?.toUpperCase() || user?.username?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700">
                {user?.name || user?.username}
              </p>
              <p className="text-xs text-gray-500">
                Personal de Limpieza
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;